import './rule.css';

interface RuleInfo {
  rule: string;
  other?: JSX.Element;
}

/** make a table of phoneme changing rules, where each array element is a rule/row */
export function RulesTable(props: { rules: RuleInfo[] }) {
  return (<table><tbody>
    {props.rules.map((r, i) => (
      <tr className='ruleRow' key={i}>
        <td className='ruleTd'><span className='rule'>{r.rule}</span></td>
        {r.other ? <td className='otherTd'>{r.other}</td> : <></>}
      </tr>))}
  </tbody></table>);
}
